<template>
  <div class="pending-payment-card">
    <div v-if="isTimedOut" class="icon-container">
      <i class="icon-checkout-warning" />
    </div>

    <spinner-component
      v-else
      class="spinner"
      :styles="spinnerStyles"
    />

    <div class="header">
      {{ isTimedOut ? 'Seu pagamento ainda está em processamento' : 'Estamos processando seu pagamento' }}
    </div>

    <div class="subheader">
      {{ isTimedOut
        ? 'A confirmação está demorando mais que o normal. Clique abaixo para verificar novamente.'
        : 'Isso pode levar alguns instantes. Por favor, aguarde a confirmação do pagamento.' }}
    </div>

    <button-component
      v-if="isTimedOut"
      class="retry-button"
      text="Tentar novamente"
      @click.native="$emit('retry')"
    />
  </div>
</template>

<script>
  import Spinner from '@/components/Spinner';
  import Button from '@/components/Button';

  export default {
    name: 'PendingPaymentCard',

    components: {
      'spinner-component': Spinner,
      'button-component': Button
    },

    props: {
      color: {
        type: String,
        default: '#FEAA3B'
      },

      isTimedOut: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      spinnerStyles() {
        return {
          size: '5px',
          color: this.color,
          borderSize: '0.8em'
        };
      }
    }
  };
</script>

<style lang="scss" scoped>
  .pending-payment-card {
    background: #FFFFFF;
    box-shadow: 0px 0px 15px rgb(0 0 0 / 5%);
    padding: 3rem 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 1rem;
    margin-bottom: 2rem;
    font-size: 14px;

    .spinner {
      margin-top: 1.5rem;
    }

    .icon-container {
      margin-top: 1.5rem;
      border-radius: 6rem;
      width: 5rem;
      height: 5rem;
      background: #FEAA3B;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        font-size: 2.9rem;
        color: #FFFFFF;
      }
    }

    .header {
      color: #6d6f6f;
      font-weight: 600;
      margin-top: 1.5rem;
      margin-bottom: 0.5rem;
      text-align: center;
      font-size: 16px;
    }

    .subheader {
      color: #6d6f6f;
      text-align: center;
      margin-bottom: 1.5rem;
      max-width: 600px;
    }

    .retry-button {
      width: auto;
      height: 36px;
      padding: 0 1.25rem;
      font-size: 14px;
    }
  }

  @media (max-width: 520px) {
    .pending-payment-card {
      padding: 3rem 1rem;
      font-size: 12px;

      .icon-container {
        width: 4rem;
        height: 4rem;

        i {
          font-size: 2.4rem;
        }
      }

      .header {
        font-size: 14px;
      }

      .subheader {
        font-size: 12px;
      }
    }
  }
</style>
